import * as _ from 'lodash'
import { TreeNodeProps } from 'rc-tree-select/lib/TreeNode'

export const getNodeParentKey: any = (key: any, tree: any) => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
            if (node.children.some((item: any) => item.value === key)) {
                parentKey = node.value
            } else if (getNodeParentKey(key, node.children)) {
                parentKey = getNodeParentKey(key, node.children)
            }
        }
    }
    return parentKey
}

export const flattenTree = (entries: TreeNodeProps[] | any): TreeNodeProps[] =>
    !entries
        ? []
        : (_.flatMapDeep(entries, (e: any) => [
              e,
              e.children ? flattenTree(e.children) : []
          ]) as TreeNodeProps[])

export const formatCurrency = (
    currencyValue: number,
    currencySymbol: string,
    decimals: number = 0
): string => {
    if (!currencyValue) {
        currencyValue = 0
    }
    return (
        currencySymbol +
        `${currencyValue
            .toFixed(decimals)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    )
}

export const formatWork = (workValue: number, workUnit: string): string => {
    if (!workValue) {
        workValue = 0
    }
    return (
        `${workValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ` +
        workUnit
    )
}

export interface ClassAndIdNames {
    className: string
    idName: string
}

export const getIdName = (cssClassName: string, id: string): string => {
    return `${cssClassName}_${id}`
}

export const getClassName = (cssClassName: string): string => {
    return cssClassName
}

export const getClassAndIdNames = (
    cssClassName: string,
    id: string
): ClassAndIdNames => {
    return {
        className: getClassName(cssClassName),
        idName: getIdName(cssClassName, id)
    }
}

export const getBasicProps = (styleName: string, id: string) => {
    const classAndIdNames: ClassAndIdNames = getClassAndIdNames(styleName, id)
    return {
        key: classAndIdNames.idName,
        className: classAndIdNames.className,
        id: classAndIdNames.idName
    }
}

export const stringToColour = (str: string) => {
    if (str) {
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }
        let colour = '#'
        for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xff
            colour += ('00' + value.toString(16)).substr(-2)
        }
        return colour
    } else {
        return '#ffffff'
    }
}
